var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { selectFirstBallotStyle, setBallotStyle, } from "../store/ballotStyles/ballotStylesSlice";
import { resetBallotSelection } from "../store/ballotSelections/ballotSelectionsSlice";
import { setElection } from "../store/elections/electionsSlice";
import { setElectionEvent } from "../store/electionEvents/electionEventsSlice";
import { setSupportMaterial } from "../store/supportMaterials/supportMaterialsSlice";
import { setDocument } from "../store/documents/documentsSlice";
import { getBallotStyleConfigurationError, } from "../services/BallotStyles";
export var updateBallotStyleAndSelection = function (ballotStyleJson, tenantId, areaId, dispatch) {
    var _a;
    dispatch(setElectionEvent(ballotStyleJson.election_event));
    for (var _i = 0, _b = ballotStyleJson.documents; _i < _b.length; _i++) {
        var document = _b[_i];
        dispatch(setDocument(document));
    }
    var electionsByAreaId = new Set(ballotStyleJson.ballot_styles
        .filter(function (ballot_style) { return ballot_style.area_id === areaId; })
        .map(function (ballot_style) { return ballot_style.election_id; }));
    for (var _c = 0, _d = ballotStyleJson.elections; _c < _d.length; _c++) {
        var election = _d[_c];
        if (electionsByAreaId.has(election.id)) {
            dispatch(setElection(__assign(__assign({}, election), { image_document_id: "", contests: [], description: (_a = election.description) !== null && _a !== void 0 ? _a : undefined })));
        }
    }
    for (var _e = 0, _f = ballotStyleJson.support_materials; _e < _f.length; _e++) {
        var material = _f[_e];
        dispatch(setSupportMaterial(material));
    }
    for (var _g = 0, _h = ballotStyleJson.ballot_styles; _g < _h.length; _g++) {
        var ballotStyle = _h[_g];
        if (ballotStyle.area_id !== areaId) {
            continue;
        }
        try {
            var eml = cloneDeep(ballotStyle);
            var configurationError = getBallotStyleConfigurationError(eml);
            if (configurationError) {
                throw configurationError;
            }
            var formattedBallotStyle = {
                id: ballotStyle.election_id,
                election_id: ballotStyle.election_id,
                election_event_id: ballotStyle.election_event_id,
                tenant_id: tenantId,
                ballot_eml: eml,
                ballot_signature: null,
                created_at: "",
                area_id: areaId,
                annotations: null,
                labels: null,
                last_updated_at: "",
            };
            dispatch(setBallotStyle(formattedBallotStyle));
            dispatch(resetBallotSelection({
                ballotStyle: formattedBallotStyle,
                force: true,
            }));
        }
        catch (error) {
            console.log("Error loading EML: ".concat(error));
            console.log(ballotStyle);
            throw error;
        }
    }
};
export var PreviewPublicationEvent = function () {
    var t = useTranslation().t;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var navigate = useNavigate();
    var _a = useParams(), tenantId = _a.tenantId, documentId = _a.documentId, areaId = _a.areaId, publicationId = _a.publicationId;
    var dispatch = useAppDispatch();
    var ballotStyle = useAppSelector(selectFirstBallotStyle);
    var location = useLocation();
    var previewUrl = useMemo(function () {
        return "".concat(globalSettings.PUBLIC_BUCKET_URL, "tenant-").concat(tenantId, "/document-").concat(documentId, "/").concat(publicationId, ".json");
    }, [tenantId, documentId, globalSettings.PUBLIC_BUCKET_URL]);
    useEffect(function () {
        var fetchPreviewData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, ballotStyleJson, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!tenantId || !areaId || !documentId || !publicationId || ballotStyle) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(previewUrl)];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("Error: ".concat(response.statusText));
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        ballotStyleJson = (_a.sent());
                        // TODO: filter elections by area_id
                        setSessionStorage();
                        updateBallotStyleAndSelection(ballotStyleJson, tenantId, areaId, dispatch);
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.log("Error loading preview: ".concat(err_1));
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchPreviewData();
    }, [previewUrl, tenantId, documentId, documentId, ballotStyle]);
    useEffect(function () {
        if ((ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.election_event_id) && tenantId && globalSettings.DISABLE_AUTH) {
            navigate("/tenant/".concat(tenantId, "/event/").concat(ballotStyle.election_event_id, "/election-chooser").concat(location.search));
        }
    }, [ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.election_event_id, tenantId, location.search, globalSettings.DISABLE_AUTH]);
    var setSessionStorage = function () {
        if (!areaId || !documentId || !publicationId) {
            return;
        }
        sessionStorage.setItem("isDemo", "true");
        sessionStorage.setItem("areaId", areaId);
        sessionStorage.setItem("documentId", documentId);
        sessionStorage.setItem("publicationId", publicationId);
    };
    return (_jsx(Box, { className: "preview-publication-screen screen", sx: { flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }, children: _jsx(CircularProgress, { className: "preview-publication-progress", "aria-label": t("a11y.loading") }) }));
};
export default PreviewPublicationEvent;
